import { CurrentEntryPoint } from './CurrentEntryPoint';
import { HubInstances } from '@scorewarrior/rubens_web_lib/lib/hub-instances';

export enum ProjectName {
    TRIUMPH = 'triumph',
    TOTALBATTLE = 'totalbattle'
}

export function getCurrentHubInstance(): HubInstances {
    return getProjectNameByCurrentPlatform() === ProjectName.TOTALBATTLE
        ? HubInstances.TOTALBATTLE
        : HubInstances.TRIUMPH;
}

export function getProjectNameByCurrentPlatform() {
    switch (window.app.config.current_entry_point) {
        case CurrentEntryPoint.SITE:
        case CurrentEntryPoint.FB:
        case CurrentEntryPoint.DESKTOP:
            return ProjectName.TRIUMPH;
        case CurrentEntryPoint.SITE2:
        case CurrentEntryPoint.DESKTOP2:
        case CurrentEntryPoint.FB2:
            return ProjectName.TOTALBATTLE;
        default:
            throw new Error('Cant get project name by entry point');
    }
}
